import axios from 'axios';

export const request = async (
	method,
	url,
	body = null,
	requestId = null,
	isFormData = false,
	options = {}
) => {
	try {
		const result = await axios({
			method,
			url,
			data: body,
			isFormData,
			requestId,
			...options
		});
		return { isError: false, status: result.status, data: result.data };
	} catch (e) {
		const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json';
		const responseData = isJsonBlob(e?.response?.data) ? await (e?.response?.data)?.text() : e?.response?.data || {};
		const responseJson = (typeof responseData === 'string') ? JSON.parse(responseData) : responseData;
		if (axios.isCancel(e)) {
			throw {
				isError: true,
				status: 'canceled'
			};
		}
		throw {
			isError: true,
			status: e.request.status,
			error: responseJson.error,
			message: responseJson.message,
			seia_code: responseJson.seia_code,
			request_id: e.response.headers['x-request-id'] ? e.response.headers['x-request-id'] : null
		};
	}
};
